import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {Link} from 'react-router-dom'

import GoodReviews from '../GoodReviews'
import GoodImage from '../GoodImage'
import GoodTitle from '../GoodTitle'
import AddToCart from '../AddToCart'
import GoodDescription from '../GoodDescription'
import {GoodPropsList} from '../GoodPropsList'
import GoodFullDescription from '../GoodFullDescription'

const Root = styled.div`
  padding: 20px;
`

const StyledLink = styled(Link)`
  color: #2d9831;
  font-weight: 600;
  font-size: 12px;
  text-decoration: none;
  border-bottom: 1px solid #78b97a;
`

const Back = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
`

const Top = styled.div`
  display: flex;
  padding: 20px 20px 30px 20px;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.07);
  background-color: white;
  overflow: hidden;
  
`

const ImgBin = styled.div`
  flex: 5;
  max-width: 400px;
`

const Overview = styled.div`
  flex: 8;
  padding-left: 30px;
`

const AddToCartBin = styled.div`
  margin-top: 29px;
  margin-bottom: 50px;
`

const PropsBin = styled.div`
  margin-top: 20px;
`

const Middle = styled.div`
  display: flex;
  padding: 28px 28px 20px 20px;
`

const FullDescriptionBin = styled.div`
  font-size: 13px;
  flex: 8;
`

const ReviewsBin = styled.div`
  ${({fullWidth}) => fullWidth
    ? css`
      flex: 1;
    ` : css`
      flex: 5;
      max-width: 400px;
      padding-left: 35px;  
    `
  }
`

const GoodPageLayout = ({
  displayCatalogType,
  referrerCategoryId,
  displayCategory,
  good,
  currentUser,
  quantityInCart,
  setQuantityInCart,
  goBack
}) => {
  const handleClickBack = (event) => {
    if (goBack) {
      event.preventDefault()
      goBack()
    }
  }

  return <Root>
    <Back>
      <div>
        <StyledLink
          to={referrerCategoryId
            ? displayCatalogType.getCategoryLink(displayCategory.id)
            : displayCatalogType.link}
          onClick={handleClickBack}
        >
          ← Назад
        </StyledLink>
      </div>
      <div>
        <StyledLink to={displayCatalogType.link}>{displayCatalogType.title}</StyledLink> /
        <StyledLink to={displayCatalogType.getCategoryLink(displayCategory.id)}>{displayCategory.title}</StyledLink>
      </div>
    </Back>

    <Top>
      <ImgBin>
        <GoodImage good={good} maxSize={800} autoScale/>
      </ImgBin>

      <Overview>
        <GoodTitle good={good} full/>
        <AddToCartBin>
          <AddToCart
            good={good}
            currentUser={currentUser}
            activeCatalogType={displayCatalogType}
            quantityInCart={quantityInCart}
            setQuantityInCart={setQuantityInCart}
          />
        </AddToCartBin>

        <GoodDescription good={good}/>
        <PropsBin>
          <GoodPropsList good={good} currentUser={currentUser} activeCatalogType={displayCatalogType}/>
        </PropsBin>
      </Overview>
    </Top>
    <Middle>
      {good.fullDescription && <FullDescriptionBin>
        <GoodFullDescription good={good}/>
      </FullDescriptionBin>}

      <ReviewsBin fullWidth={!good.fullDescription}>
        <GoodReviews good={good} compact={!!good.fullDescription}/>
      </ReviewsBin>
    </Middle>
  </Root>
}

export default GoodPageLayout
